













import {Vue, Component} from 'vue-property-decorator';
import {toI18n} from '@/utils/commonUtils';

@Component
export default class ServiceRegisterError extends Vue {
  private toI18n (needToI18nStr: string, bCommon: boolean = false): string {
    return toI18n(this.$t((bCommon ? '' : 'SERVICE_REGISTER_') + needToI18nStr));
  }
}
